import React from "react";

import LandingPageDesignWeb from "./../../components/LandingPageDesignWeb";
import LandingPageDesignMobile from "./../../components/LandingPageDesignMobile";
import OurTeamContent from "../../components/PageContents/OurTeamContent";
import { Col, Row } from "antd";

function OurTeam(props) {
  return (
    <Row>
      <Col
        xs={{ span: 0 }}
        sm={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 24 }}
        xl={{ span: 24 }}
        xxl={{ span: 24 }}
        style={{ margin: 0 }}
      >
        <LandingPageDesignWeb Children={OurTeamContent} {...props} />
      </Col>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 24 }}
        xl={{ span: 24 }}
        xxl={{ span: 24 }}
        style={{ margin: 0 }}
      >
        <LandingPageDesignMobile Children={OurTeamContent} {...props} />
      </Col>
      {/* <div className="app">
        <Intercom appID="s929xz39" {...user} />
      </div> */}
    </Row>
  );
}

export default OurTeam;
